import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'

/**
 * Drop-in replacement for `useTranslations` de `next-intl`.
 *
 * Permite migrar componentes con cambio mínimo:
 *   import { useTranslations } from 'next-intl'   →   import { useTranslations } from '@/i18n/useTranslations'
 *
 * Uso idéntico:
 *   const t = useTranslations('Hero')
 *   t('title')              → t('Hero.title')
 *   t('title', { name })    → interpolación estándar i18next
 */
export function useTranslations(namespace?: string) {
  const { t } = useTranslation()
  return useCallback(
    (key: string, vars?: Record<string, unknown>) => {
      const fullKey = namespace ? `${namespace}.${key}` : key
      return t(fullKey, vars as Record<string, unknown>) as string
    },
    [t, namespace],
  )
}

/** Re-export utilitario para componentes que sólo necesiten el cambio de idioma */
export { useTranslation } from 'react-i18next'
